import { KlauselwerkSeite } from "./VertragstextPage";

/**
 * Die AGB pflegen — eine eigene Seite neben dem Vertragstext.
 *
 * Bis zum 28.09.2026 waren die AGB ein Reiter im Vertragstext-Editor, und ein
 * Abschnitt kam über „→ in die AGB" dorthin. Benjamin: „echt verwirrend — für
 * die AGB braucht es gesondert eine Seite". Technisch bleiben sie ein Blatt
 * derselben Fassung: der Vertrag verweist auf ihre Paragrafen, und beides wird
 * zusammen freigegeben. Was der Kunde sieht, steht unter
 * pflege.vimaanagarten.de/agb.
 */
export default function AgbPage() {
  return <KlauselwerkSeite modus="agb" />;
}
